import script from "./SiteLayout.vue?vue&type=script&lang=ts"
export * from "./SiteLayout.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__